import { useLoggedUserContext } from "../../contexts/LoggedUserContext";
export default function Features() {
  const { CurrentPage } = useLoggedUserContext();

  return <>{<CurrentPage />}</>;
}
